// store/filterApiSlice.ts
import { ntxAPI } from '@API/axiosNeatex';
import { createSlice, createAsyncThunk, type PayloadAction } from '@reduxjs/toolkit';
import { type APIResponse } from './Shared/shared';

// أنواع البيانات الثابتة
export const FilterOperator = {
  Equal: 0,
  NotEqual: 1,
  GreaterThan: 2,
  GreaterThanOrEqual: 3,
  LessThan: 4,
  LessThanOrEqual: 5,
  Contains: 6,
  StartsWith: 7,
  EndsWith: 8
} as const;
export type FilterOperator = (typeof FilterOperator)[keyof typeof FilterOperator];

interface FilterItem {
  field: string;
  operator: FilterOperator;
  value: string;
  useOr: boolean; // دائماً false
}

interface SortOrder {
  field: string;
  descending: boolean;
}

interface ApiRequest {
  pageIndex: number;
  pageSize: number;
  filters: FilterItem[];
  sortOrders: SortOrder[];
  includes: string[]; // مهمل مؤقتاً
  extraFilters: string; // مهمل مؤقتاً
}

interface ApiState {
  data: any[];
  loading: boolean;
  error: string | null;
  request: ApiRequest;
  totalCount: number;
}

const initialState: ApiState = {
  data: [],
  loading: false,
  error: null,
  totalCount: 0,
  request: {
    pageIndex: 0,
    pageSize: 10,
    filters: [],
    sortOrders: [],
    includes: [],
    extraFilters: ''
  }
};

// Async Thunk يمكن تخصيصه لكل API
export const fetchDataWithFilters = createAsyncThunk(
  'filterApi/fetchData',
  async ({ endPoint, request }: { endPoint: string; request: ApiRequest }, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>(endPoint, request);
      // return data;

      if (!data.succeeded) {
        throw new Error('Network response was not ok');
      }

      return data.data;
      // return await response.json();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const filterApiSlice = createSlice({
  name: 'filterApi',
  initialState,
  reducers: {
    updateFilters: (state, action: PayloadAction<FilterItem[]>) => {
      state.request.filters = action.payload;
    },
    updateSortOrders: (state, action: PayloadAction<SortOrder[]>) => {
      state.request.sortOrders = action.payload;
    },
    updatePagination: (state, action: PayloadAction<{ pageIndex: number; pageSize: number }>) => {
      state.request.pageIndex = action.payload.pageIndex;
      state.request.pageSize = action.payload.pageSize;
    },
    resetFilters: state => {
      state.request.filters = [];
      state.request.sortOrders = [];
      state.request.pageIndex = 0;
    },
    setRequestData: (state, action: PayloadAction<Partial<ApiRequest>>) => {
      state.request = { ...state.request, ...action.payload };
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchDataWithFilters.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDataWithFilters.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.items || action.payload;
        state.totalCount = action.payload.totalCount || action.payload.length;
      })
      .addCase(fetchDataWithFilters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
});

export const { updateFilters, updateSortOrders, updatePagination, resetFilters, setRequestData } =
  filterApiSlice.actions;
export default filterApiSlice.reducer;
